<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <div v-if="timeCorrect">
        <router-view :key="$route.fullPath" />
        <Fade></Fade>
      </div>
      <div v-else>
        <TimeTips @reload="reload"></TimeTips>
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import Fade from '@/components/Fade'
import TimeTips from '@/components/TimeTips'

// import { AppDeviceEnquire } from '@/utils/mixin'

export default {
  // mixins: [AppDeviceEnquire],
  components: {
    Fade,
    TimeTips,
  },
  data() {
    return {
      timeCorrect: true,
      zhCN,
    }
  },
  created() {
    this.netTime()
  },
  methods: {
    netTime() {
      var _that = this
      var xhr = new XMLHttpRequest()
      xhr.open('GET', 'https://apoit.accfun.com/sso.html?query_timestamp&partner=1', true)
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      xhr.send(null)
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var json = xhr.responseText
          var timestamp = JSON.parse(json).timestamp
          // var dateTmp = tiem.replace(/-/g, '/')   //为了兼容IOS，需先将字符串转换为'2018/9/11 9:11:23'
          // var timestamp = Date.parse(dateTmp)    //转换为时间戳
          let localTime = Date.parse(new Date())
          if (timestamp - localTime > 900000 || timestamp - localTime < -900000) {
            console.log('timestamp', timestamp)
            console.log('localTime', localTime)

            console.log(timestamp - localTime + '')
            _that.timeCorrect = false
          } else {
            console.log('当前时间正常')
          }
        }
      }
    },
    reload() {
      setTimeout(() => {
        window.location.reload()
      }, 30000)
    },
  },
  // mounted() {
  //   list.map(item=>{
  //     const arr = item.prop.split('.')
  //     arr.forEach(v=>{
  //       v
  //     })
  //     return {prop:value,label:item.label}
  //   })
  // },
}
</script>
<style>
.text-center {
  text-align: center;
}
</style>
